import getCalendarPickerStore from '../selectors/getCalendarPickerStore';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';

export default function isCreatingCalendarGroup(
    scenarioId: CalendarPickerScenarioId,
    userIdentity: string
): boolean {
    return getCalendarPickerStore(scenarioId).accountCreatingCalendarGroup == userIdentity;
}
